module.exports = __webpack_public_path__ + "img/desktop_search.35dbb250.jpg";